export function login(){
  window.location.href = process.env.REACT_APP_CLOUD_LAB_URL + "/login/callback?redirect=" + encodeURIComponent(window.location.href);
}
export function yuqueLogin(){
  window.location.href = `${process.env.REACT_APP_YUQUE_OAUTH_URL}${encodeURIComponent(window.location.href)}`;
}

export const checkLogin = (authInfo, yuque) => {
  if (!authInfo.isLogin) {
    if (yuque){
      yuqueLogin()
    }else{
      login()
    }
    return false;
  }
  return true;
}
export const checkBind = (authInfo) => {
  if (authInfo?.userInfo?.isBind){
    return true;
  }else{
    window.location.href = `${process.env.REACT_APP_CLOUD_LAB_URL}/oauth/callback?bind=true&tid=${authInfo.token}&redirect=${encodeURIComponent(window.location.href)}&showInvitation=false&bindSuccessTip=true`
  }
}